import { useState } from "react";
import NavigationBar from "../comps/NavigationBar/NavigationBar";
import Footer from "../comps/Footer/Footer";
import ContentCard from "../comps/ContentCard/ContentCard";
import Sidebar from "../comps/Sidebar/Sidebar";

export default function Medal() {
  const menu = [
    {
      name: "Bronze",
      id: "Medal-0",
    },
    {
      name: "Sliver",
      id: "Medal-1",
    },
    {
      name: "Gold",
      id: "Medal-2",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  const handleScroll = () => {
    const scrollTop = document.scrollTop;

    const menuItems = menu.map((item) => item.id); // 所有menu项的id

    let activeIndex = 0;

    menuItems.forEach((id, index) => {
      const elem = document.getElementById(id);
      console.log(elem);
      if (scrollTop >= elem.offsetTop - 110) {
        activeIndex = index;
        console.log(activeIndex);
      }
    });

    setActiveIndex(activeIndex);
  };

  // useEffect(() => {
  //   const contentElement = elem;

  //   if (contentElement) {
  //     document.addEventListener("scroll", handleScroll);
  //   }
  //   return () => {
  //     if (contentElement) {
  //       document.removeEventListener("scroll", handleScroll);
  //     }
  //   };
  // }, []);

  return (
    <div className="general-background" onScroll={handleScroll}>
      <NavigationBar />
      <Sidebar menu={menu} activeIndex={activeIndex} />
      <div className="main-container">
        <p className="title">MEDAL</p>
        <ContentCard
          content={` 
            <b>
            We eventually meet the following criteria for Bronze, Silver and Gold Medal.
            </b>
            <br/>
            <b>
            Result: Gold Medal
            </b>
            <br/>
              `}
        />
        <p className="subtitle" key={"Medal-0"} id="Medal-0">
          • Bronze
        </p>
        <ContentCard
          content={` 
            <b>★Completed all Competition Deliverables</b>  
            <br/>
            <p>
            #1 Wiki: we completed a well-designed and straightforward wiki to introduce our project.
            </p>
            <br/>
            <p>
            #2 Promotion Promotion Video: we made an excellent <a href="https://video.igem.org/w/tJEAdj5L6xn96uJbb3GZLo">promotion video</a> to demonstrate our project.
            </p>
            <br/>
            <p>
            #3 Judging Form: Here is our <a href="https://old.igem.org/2023_Judging_Form?id=4826">Judging Form</a>.
            </p>
            <br/>
            <p>
            #4 Presentation Video: we will publish our presentation video soon to give others a better understanding of our project.
            </p>
            <br/>
            <p>
            #5 Judging Session: we are ready for the judging session in the coming jamboree.
            </p>
            <br/>
            <b>★Project Attributions</b>  
            <br/>
            <p>
            Thanks to all the people for their effort in this project!
            </p>
            <br/>
            <p>
            Please click <a href="https://2023.igem.wiki/sysu-software/attributions">Attributions</a> for more details.
            </p>
            <br/>
            <b>★Project Description</b> 
            <p>
            We definitely finished and gave out a project design.
            </p>
            <br/>
            <p>
            Please click <a href="https://2023.igem.wiki/sysu-software/description">Description</a> for more details.
            </p>
            <br/>
            <b>★Contribution</b> 
            <p>
            We established a useful database and a well-modeled tool for researchers who are interested in eCISs or therapeutic protein delivery systems. In addition, we made a business plan, which will promote the industrialization of eCISs.
            </p>
            <br/>
            <p>
            Please click <a href="https://2023.igem.wiki/sysu-software/contribution">Contribution</a> for more details.
            </p>
            `}
        />
        <p className="subtitle" key={"Medal-1"} id="Medal-1">
          • Silver
        </p>
        <ContentCard
          content={` 
            <b>★Engineering Success</b>  
            <br/>
            <p>
            Our team combined forward engineering and reverse engineering strategies, both of which followed the engineering design cycle, to reach the goal of predicting and understanding eCISs.
            </p>
            <br/>
            <p>
            Please click <a href="https://2023.igem.wiki/sysu-software/engineering">Engineering</a> for more details.
            </p>
            <br/>
            <b>★Human Practices</b>  
            <br/>
            <p>
            The ultimate goal of our project is to help the world: our database and model definitely provide effective tools to put forward further research of synthetic biology; our business plan will indeed promote the therapeutic protein delivery.
            </p>
            <br/>
            <p>
            Please click <a href="https://2023.igem.wiki/sysu-software/human-practices">Human Practices</a> for more details.
            </p>
            `}
        />
        <p className="subtitle" key={"Medal-2"} id="Medal-2">
          • Gold
        </p>
        <ContentCard
          content={` 
            <b>★Model</b>  
            <br/>
            <p>
            Compared to the traditional search methods that solely relied on sequence similarity, we are now, for the first time, utilizing machine learning to process sequence information and incorporating structural information into the eCIS mining process.
            </p>
            <br/>
            <p>
            Please click <a href="https://2023.igem.wiki/sysu-software/model">Model</a> for more details.
            </p>
            <br/>
            <b>★Integrated Human Practices</b>  
            <br/>
            <p>
            Receiving plenty of needs and suggestions from different perspectives, we optimized our design, model and analyzing pipeline to improve our project. In the meanwhile, we committed to contributing to the world.
            </p>
            <br/>
            <p>
            Please click <a href="https://2023.igem.wiki/sysu-software/human-practices">Human Practice</a> for more details.
            </p>
            <br/>
            <b>★Entrepreneurship</b>  
            <br/>
            <p>
            We launched our business plan for Biorocket – a therapeutic protein delivery service company with assistance from synthetic biology and artificial intelligence.
            </p>
            <br/>
            <p>
            Please click <a href="https://2023.igem.wiki/sysu-software/entrepreneurship">Entrepreneurship</a> for more details.
            </p>
            `}
        />
      </div>
      <Footer />
    </div>
  );
}
